import ActionTypes from '../constants/ActionTypes';
import standardAction from '../../../utilities/standard-action';

export default function getRecentSearches(recent = []) {
  return standardAction(ActionTypes.GET_RECENT_SEARCHES, recent);
}
